export default __webpack_public_path__ + "static/media/add_main_image.b41fd083.svg";